import { ReactNode } from 'react';

import { IWallet } from './wallet.model';

const walletsHeaders = [
  'iban',
  'eventName',
  'walletStatus',
  'userId',
  'bic',
  'solde',
  'authorizedBalance',
  'createdDate',
] as const;

type THeadersKeys = (typeof walletsHeaders)[number];
export type TAllWalletsRowType = {
  [key in keyof Pick<IWallet, THeadersKeys> | 'actions']: ReactNode;
};
export const allWalletsHeadersList: (keyof TAllWalletsRowType)[] = [...walletsHeaders, 'actions'] as const;
